import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiAppBar: Overrides['MuiAppBar'] = {
  colorPrimary: {
    backgroundColor: pallete.common.white,
  },
};

export default MuiAppBar;
